import { service } from '../axios';
export function getConsLocationTreeByWarehouse(warehouseId) {
    return service({
        url: '/cons/location/tree',
        method: 'get',
        params: { warehouseId }
    });
}
export function searchCons(params) {
    return service({
        url: '/cons/searchCons',
        method: 'get',
        params
    });
}
export function buildCourseOut(data) {
    return service({
        url: '/labCourseConsumable/buildCourseOut',
        method: 'post',
        data,
    });
}
export function saveCourseOut(data) {
    return service({
        url: '/labCourseConsumable/saveCourseOut',
        method: 'post',
        data,
    });
}
